import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Fetcher from '../util/Fetcher';
import t from '@instructure/quiz-i18n/format-message';
import { handleError } from '../api/helpers';
import { handleShareBanksResponse } from '../api/callHandlers';
import { CAN_EDIT, SHARED_WITH_USER, SHARED_WITH_COURSE, SHARED_WITH_ACCOUNT, GET_SHARED_BANKS } from '@instructure/quiz-common';
import { sharedBankLoadingAction } from '../../common/actions/sharingModal';
var banksApiEndpoint = '/api/banks';
var chunkSize = 200;
function getAllinfo(_x, _x2) {
  return _getAllinfo.apply(this, arguments);
}
function _getAllinfo() {
  _getAllinfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(func, uuids) {
    var info, i, nextChunk, nextData, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          info = [];
          for (i = 0; i < uuids.length; i += chunkSize) {
            nextChunk = uuids.slice(i, i + chunkSize);
            nextData = func(nextChunk);
            info.push(nextData);
          }
          _context2.prev = 2;
          _context2.next = 5;
          return Promise.all(info);
        case 5:
          result = _context2.sent;
          return _context2.abrupt("return", result.flat());
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](2);
          console.error('Error fetching user info', _context2.t0);
          return _context2.abrupt("return", []);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 9]]);
  }));
  return _getAllinfo.apply(this, arguments);
}
function getSharedBankUsers(_x3, _x4) {
  return _getSharedBankUsers.apply(this, arguments);
}
function _getSharedBankUsers() {
  _getSharedBankUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(sharedBanksInfo, getUserInfo) {
    var userSharedBanks, userUuids, usersInfo;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          userSharedBanks = [];
          userUuids = sharedBanksInfo.filter(function (sb) {
            return sb.entity_type === SHARED_WITH_USER;
          }).map(function (sb) {
            return sb.entity_id;
          });
          _context3.next = 4;
          return getAllinfo(getUserInfo, userUuids);
        case 4:
          usersInfo = _context3.sent;
          usersInfo.forEach(function (userInfo) {
            var sharedBankInfo = sharedBanksInfo.find(function (sb) {
              return sb.entity_type === SHARED_WITH_USER && sb.entity_id === userInfo.uuid;
            });
            if (sharedBankInfo) {
              userSharedBanks.push({
                id: sharedBankInfo.id,
                entityType: sharedBankInfo.entity_type,
                entityId: sharedBankInfo.entity_id,
                title: userInfo.fullName,
                avatar: userInfo.avatar,
                permission: sharedBankInfo.permission,
                bankId: sharedBankInfo.bank_id
              });
            }
          });
          return _context3.abrupt("return", userSharedBanks);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getSharedBankUsers.apply(this, arguments);
}
function getSharedBankCourses(_x5, _x6) {
  return _getSharedBankCourses.apply(this, arguments);
}
function _getSharedBankCourses() {
  _getSharedBankCourses = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(sharedBanksInfo, getCourseInfo) {
    var courseSharedBanks, courseUuids, coursesInfo;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          courseSharedBanks = [];
          courseUuids = sharedBanksInfo.filter(function (sb) {
            return sb.entity_type === SHARED_WITH_COURSE;
          }).map(function (sb) {
            return sb.entity_id;
          });
          _context4.next = 4;
          return getAllinfo(getCourseInfo, courseUuids);
        case 4:
          coursesInfo = _context4.sent;
          coursesInfo.forEach(function (courseInfo) {
            var sharedBankInfo = sharedBanksInfo.find(function (sb) {
              return sb.entity_type === SHARED_WITH_COURSE && sb.entity_id === courseInfo.uuid;
            });
            if (sharedBankInfo) {
              courseSharedBanks.push({
                id: sharedBankInfo.id,
                entityType: sharedBankInfo.entity_type,
                entityId: sharedBankInfo.entity_id,
                title: courseInfo.title,
                permission: sharedBankInfo.permission,
                bankId: sharedBankInfo.bank_id
              });
            }
          });
          return _context4.abrupt("return", courseSharedBanks);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getSharedBankCourses.apply(this, arguments);
}
function getSharedBankAccounts(_x7, _x8) {
  return _getSharedBankAccounts.apply(this, arguments);
}
function _getSharedBankAccounts() {
  _getSharedBankAccounts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sharedBanksInfo, getAccountInfo) {
    var accountSharedBanks, accountUuids, accountsInfo;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          accountSharedBanks = [];
          accountUuids = sharedBanksInfo.filter(function (sb) {
            return sb.entity_type === SHARED_WITH_ACCOUNT;
          }).map(function (sb) {
            return sb.entity_id;
          });
          _context5.next = 4;
          return getAllinfo(getAccountInfo, accountUuids);
        case 4:
          accountsInfo = _context5.sent;
          accountsInfo.forEach(function (accountInfo) {
            var sharedBankInfo = sharedBanksInfo.find(function (sb) {
              return sb.entity_type === SHARED_WITH_ACCOUNT && sb.entity_id === accountInfo.uuid;
            });
            if (sharedBankInfo) {
              accountSharedBanks.push({
                id: sharedBankInfo.id,
                entityType: sharedBankInfo.entity_type,
                entityId: sharedBankInfo.entity_id,
                title: accountInfo.name,
                permission: sharedBankInfo.permission,
                bankId: sharedBankInfo.bank_id
              });
            }
          });
          return _context5.abrupt("return", accountSharedBanks);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getSharedBankAccounts.apply(this, arguments);
}
export var createSharedBanksMiddleware = function createSharedBanksMiddleware() {
  return function (store) {
    return function (next) {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
          var _action$payload, bank, getUserInfo, getCourseInfo, getAccountInfo, dispatch, url, startLoading, fetcher, sharedBanksInfo, users, courses, accounts, endLoading;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(action.type === GET_SHARED_BANKS)) {
                  _context.next = 23;
                  break;
                }
                _action$payload = action.payload, bank = _action$payload.bank, getUserInfo = _action$payload.getUserInfo, getCourseInfo = _action$payload.getCourseInfo, getAccountInfo = _action$payload.getAccountInfo;
                dispatch = store.dispatch;
                url = "".concat(banksApiEndpoint, "/").concat(bank.id, "/shared_banks");
                startLoading = {
                  loading: true
                };
                dispatch(sharedBankLoadingAction(startLoading));
                fetcher = new Fetcher({
                  onError: handleError(dispatch, t('Failed to fetch shared banks.'))
                });
                _context.next = 9;
                return fetcher.get(url);
              case 9:
                sharedBanksInfo = _context.sent;
                // Add bank creator if no data
                if (sharedBanksInfo.length === 0) {
                  sharedBanksInfo.push({
                    id: '-1',
                    entity_type: SHARED_WITH_USER,
                    entity_id: bank.creator,
                    permission: CAN_EDIT,
                    bank_id: bank.id
                  });
                }
                _context.next = 13;
                return getSharedBankUsers(sharedBanksInfo, getUserInfo);
              case 13:
                users = _context.sent;
                _context.next = 16;
                return getSharedBankCourses(sharedBanksInfo, getCourseInfo);
              case 16:
                courses = _context.sent;
                _context.next = 19;
                return getSharedBankAccounts(sharedBanksInfo, getAccountInfo);
              case 19:
                accounts = _context.sent;
                dispatch(handleShareBanksResponse(users.concat(courses).concat(accounts)));
                endLoading = {
                  loading: false
                };
                dispatch(sharedBankLoadingAction(endLoading));
              case 23:
                return _context.abrupt("return", next(action));
              case 24:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x9) {
          return _ref.apply(this, arguments);
        };
      }();
    };
  };
};